import { PolygonRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasPolygonPicker } from "../constants";

import { DefaultCanvasPolygonPicker } from "./polygon-picker";

let loadPolygonPick = !1;

export function bindPolygonCanvasPickerContribution(container) {
    loadPolygonPick || (loadPolygonPick = !0, container.bind(CanvasPolygonPicker).toDynamicValue((() => new DefaultCanvasPolygonPicker(resolveContainerBinding(container, PolygonRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasPolygonPicker));
}
//# sourceMappingURL=polygon-module.js.map
